export const TAG_CONTENT = "inno:content";
export const TAG_DATAPOINT = "inno:datapoint";
export const TAG_META = "inno:meta";
export const ATTR_CONFIDENCE = "confidence";
export const ATTR_KEY = "key";
export const ATTR_ID = "id";
export const ATTR_ID_REF = "idref";
